module.exports = __webpack_public_path__ + "img/login-victoriacentral.1b77bda5.svg";